import z from 'zod';

import i18n from '@dms/i18n';

import {EMAIL_REGEX} from '../constants/EMAIL_REGEX';

export const SendCustomerEmailFormSchema = z
  .object({
    subject: z.string().optional(),
    body: z.string().optional(),
    customerId: z.string(),
    copyTo: z.array(z.string()).optional(),
    smtpCredentialsId: z.string(),
    customerMessageId: z
      .array(z.enum(['customer-message', 'service-customer_check_in', 'service-customer_handover']))
      .min(1, {message: i18n.t('errors.field_is_required')}),
    customerEmailAddress: z.string().regex(EMAIL_REGEX, {
      message: i18n.t('errors.invalid_string.email'),
    }),
  })
  .refine(
    (data) => {
      if (data.customerMessageId?.[0] === 'customer-message') {
        return !!data.subject;
      }
      return true;
    },
    {
      message: i18n.t('errors.field_is_required'),
      path: ['subject'],
    }
  )
  .refine(
    (data) => {
      if (data.customerMessageId?.[0] === 'customer-message') {
        return !!data.body;
      }
      return true;
    },
    {
      message: i18n.t('errors.field_is_required'),
      path: ['body'],
    }
  );

export type FormValues = z.infer<typeof SendCustomerEmailFormSchema>;
